// extracted by mini-css-extract-plugin
export default {"wrapper":"CreditData_wrapper__0C21X","left":"CreditData_left__qO8Zc"};